export default __webpack_public_path__ + "static/media/FionaPaola.ede87a8a.png";